<template>
  <div class="container">
      <NavbarSimple :leftText="$t('common.profitList')"></NavbarSimple>
      <div class="wrapper">
          <div class="block1">

        </div>
        <div class="block2">
            <div class="td">{{$t('common.date')}}</div>
            <div class="td">{{$t('common.profitRate')}}</div>
            <div class="td">{{$t('common.amount')}}</div>
            <template v-for="elem of data.rows">
                <div class="td" :key="elem.id">{{elem.createdAt.split(' ')[0]}}</div>
                <div class="td" :key="elem.id">{{Number.parseFloat((elem.profitRate * 100).toFixed(2))}}%</div>
                <div class="td" :key="elem.id">{{elem.amount}} USDT</div>
            </template>
            <div style="width:100%;display:flex;justify-content: flex-end;">
                <van-pagination v-model="page" @change="_fetch" :total-items="data.count" :show-page-size="size" mode="simple">
                    <template #prev-text>
                        <van-icon name="arrow-left" />
                    </template>
                    <template #next-text>
                        <van-icon name="arrow" />
                    </template>
                </van-pagination>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'profitList',
    components: {
        NavbarSimple,
    },
    data() {
        return {
            page: 1,
            size: 10,
            data: {
                count: 0,
                rows: []
            }
        }
    },
    mounted() {
    this.token = localStorage.getItem('token');
    this._fetch();
  },
  methods: {
    _fetch() {
        this.apiV1({
            method: 'get',
            url: '/trading/receivedRecord',
            params: {
                page: this.page,
                size: this.size
            },
            headers: {'Authorization': this.token}
        }).then(response => {
            const { success, data } = response.data;
            if (success) {
                this.data = data;
            }
        })
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
    margin-top: 4rem;
    padding: 4rem;
    font-size: 3.467rem;
    color: #000;
    background-color: @app-theme-color4;
    border: 0.267rem solid @app-theme-color1;
    border-radius: 5.333rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .block2 {
        background-color: #d6b593;
        border: 0.267rem solid #814000;
        color: #814000;
        border-radius: 4rem;
        padding: 3.888rem;
        width: 85rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 5.333rem;
        .td {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 33%;
            height: 8rem;
            border-radius: 0.8rem;
        }
    }
}
</style>